<div class="home-root">
  @if (isLoading) {
    <div class="loading-spinner"> Loading... </div>
  }

  @if (errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
  }
  @if (userData) {
    <div class="video-overlay overlay-content">
      <app-video-player
        [playsinline]="true"
        [options]="{
          fluid: true,
          fill: false,
          responsive: false,
          autoplay: false,
          controls: true,
          controlBar: { fullscreenToggle: false, pictureInPictureToggle: false },
          sources: [
            {
              src: videoUrl,
              type: 'video/mp4',
            },
          ],
        }"
        [markers]="markers"
        (videoResizeEvent)="onVideoResize($event)"
        (playStarted)="onPlayStarted($event)"
        (markerState)="onMarkerChange($event)"
        (markerClicked)="onMarkerClicked($event)">
      </app-video-player>
      @if (activeOverlay() === OverlayType.START) {
        <app-start-overlay [viewportSize]="currentViewportSize" [user]="userData" [message]="message" @fadeOut>
        </app-start-overlay>
      }
      @if (activeOverlay() === OverlayType.WELCOME) {
        <app-welcome-overlay
          [user]="userData"
          [message]="message"
          [viewportSize]="currentViewportSize"
          @slideFromRightAndFade>
        </app-welcome-overlay>
      }
      @if (activeOverlay() === OverlayType.RELAX) {
        <app-relax-overlay [viewportSize]="currentViewportSize" @slideFromRightAndFade> </app-relax-overlay>
      }
      @if (activeOverlay() === OverlayType.BOOKMARK_KNOW) {
        <app-bookmark-know-overlay
          (linkClick)="handleOverlayLinkClick()"
          [viewportSize]="currentViewportSize"
          @slideFromLeftAndFade>
        </app-bookmark-know-overlay>
      }
      @if (activeOverlay() === OverlayType.BOOST_YOUR_KNOWLEDGE) {
        <app-boost-your-knowledge-overlay
          (linkClick)="handleOverlayLinkClick()"
          [viewportSize]="currentViewportSize"
          @slideFromLeftAndFade>
        </app-boost-your-knowledge-overlay>
      }
      @if (activeOverlay() === OverlayType.COMMUNITY_PART_1) {
        <app-build-your-community-part-one-overlay
          (linkClick)="handleOverlayLinkClick()"
          [role]="userData?.highestRole"
          [viewportSize]="currentViewportSize"
          @slideFromTopAndFade>
        </app-build-your-community-part-one-overlay>
      }
      @if (activeOverlay() === OverlayType.COMMUNITY_PART_2) {
        <app-build-your-community-part-two-overlay
          (linkClick)="handleOverlayLinkClick()"
          [viewportSize]="currentViewportSize"
          @slideFromTopAndFade>
        </app-build-your-community-part-two-overlay>
      }
      @if (activeOverlay() === OverlayType.EVENTS) {
        <app-events-overlay
          [role]="userData?.highestRole"
          [region]="userData?.region"
          (linkClick)="handleOverlayLinkClick()"
          [viewportSize]="currentViewportSize"
          @slideFromTopAndFade>
        </app-events-overlay>
      }
      @if (activeOverlay() === OverlayType.EDUCATION_COURSE) {
        <app-education-overlay
          [role]="userData?.highestRole"
          (linkClick)="handleOverlayLinkClick()"
          [viewportSize]="currentViewportSize"
          @slideFromRightAndFade>
        </app-education-overlay>
      }
      @if (activeOverlay() === OverlayType.CONTACT_US) {
        <app-contact-us-overlay
          [role]="userData?.highestRole"
          [userName]="userData?.name"
          (linkClick)="handleOverlayLinkClick()"
          [viewportSize]="currentViewportSize"
          @slideFromTopAndFade>
        </app-contact-us-overlay>
      }
      @if (activeOverlay() === OverlayType.SUMMARY) {
        <app-summary-overlay
          [role]="userData?.highestRole"
          [userName]="userData?.name"
          [viewportSize]="currentViewportSize"
          (replay)="onReplay()">
        </app-summary-overlay>
      }
    </div>
  }
</div>
